
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/followers",
      function () {
        return require("private-next-pages/dashboard/followers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/followers"])
      });
    }
  